import React from 'react';
import PropTypes from 'prop-types';
import BoxedItem from '../boxed-item';

import './payments.scss';

const SavedCreditCard = (props) => {
  return (
    <BoxedItem
      className="savedCreditCard"
      onClick={() => props.onSelect(props.id)}
      active={props.active}
    >
      <div className="savedCreditCard__main">
        <div className="savedCreditCard__image">
          {props.brand &&
            <img src={`https://static.arreeba.com/cc/${props.brand.toLowerCase()}.png`} alt={props.brand} />
          }
        </div>
        <p className="savedCreditCard__number">XXXX-XXXX-XXXX-{props.last4}</p>
      </div>
      <p className="savedCreditCard__expDate">{props.exp_month}/{props.exp_year}</p>
    </BoxedItem>
  );
};

SavedCreditCard.propTypes = {
  brand: PropTypes.string,
  exp_month: PropTypes.string,
  exp_year: PropTypes.string,
  id: PropTypes.string,
  last4: PropTypes.string,
  onSelect: PropTypes.func,
  active: PropTypes.bool,
};

export default SavedCreditCard;



// WEBPACK FOOTER //
// ./src/components/payment/saved-credit-card.js